// extracted by mini-css-extract-plugin
export default {"wrapper":"MarkdownParser_wrapper__bKKpG"};